import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UpdateVariableBenefitConfigurationSubmission } from '../../../../../../models/submissions/update-variable-benefit-configuration-submission';

@Component({
  selector: 'app-update-vb-config-account-details-review-card',
  templateUrl: './update-vb-config-account-details-review-card.component.html',
  styleUrls: ['./update-vb-config-account-details-review-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateVbConfigAccountDetailsReviewCardComponent {
  @Input({ required: true }) submission!: UpdateVariableBenefitConfigurationSubmission;
  @Input() boardDirectedAccount = false;
}
